exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#keyword-answers[data-v-2a02cf18]{border:1px solid #eaedf3;border-radius:5px}#keyword-answers .title[data-v-2a02cf18]{font-size:20px;font-weight:700;color:#38404f}#keyword-answers .body[data-v-2a02cf18]{font-size:14px}", ""]);

// exports
